/*
*
* SoftPos Api
*
* @version 1.0.0
* @author Giorgia Cuozzo
* @since 04-Jun-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/softPos/softPos')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getShopsList (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posisp/shop/list',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function submit (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/marketing-service/posisp/submit',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getOrders (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posisp/orders',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
